export function checkTokenInStorage() {
  return !!localStorage.getItem("token") && !!localStorage.getItem("refresh");
}
